"use client";

import { addMinutes } from "date-fns";
import { Button } from "@/components/ui/button";
import { TimeSlot } from "@/types/slots";
import { cn } from "@/lib/utils";
import { formatInTimeZone } from "date-fns-tz";

export function SlotBtn({
  slot,
  duration,
  timeZone,
  use24Hour,
  timeFormat,
  isCapacityPublic,
  onTimeSelect,
}: {
  slot: TimeSlot;
  duration: number;
  timeZone: string;
  use24Hour: boolean;
  timeFormat: string;
  isCapacityPublic: boolean;
  onTimeSelect: (time: string, duration: number, time_zone: string) => void;
}) {
  const timeFmt = use24Hour ? "HH:mm" : "h:mm a";
  const timeLabel =
    timeFormat === "hh:mm - hh:mm"
      ? `${formatInTimeZone(slot.time, timeZone, timeFmt)} - ${formatInTimeZone(
          addMinutes(slot.time, duration),
          timeZone,
          timeFmt
        )}`
      : formatInTimeZone(slot.time, timeZone, timeFmt);

  return (
    <Button
      key={slot.time}
      variant="outline"
      onClick={() => onTimeSelect(slot.time, duration, timeZone!)}
      className={cn(
        "w-full justify-center font-normal relative",
        isCapacityPublic ? "py-8" : ""
      )}
      disabled={!slot.available}
    >
      <div className="flex flex-col items-center">
        <div
          className={cn("flex items-center gap-2", {
            "line-through": !slot.available,
          })}
        >
          <span
            className={`w-2 h-2 rounded-full ${
              slot.available ? "bg-green-500" : "bg-red-500"
            }`}
          />
          {timeLabel}
        </div>
        {isCapacityPublic && (
          <p className="text-sm text-muted-foreground">
            {slot.available} spots left
          </p>
        )}
      </div>
    </Button>
  );
}
